import {
  useRouteError,
  isRouteErrorResponse,
  useNavigate,
} from "react-router-dom";
import * as Sentry from "@sentry/react";
import { errorHandler } from "./services/errorHandler/errorHandler";
import { HttpError } from "./types/errorTypes/httpError";

export default function ErrorPage() {
  const error = useRouteError();
  const navigate = useNavigate();

  function getErrorMessage() {
    if (isRouteErrorResponse(error)) {
      if (error.status >= 500) {
        Sentry.captureException(
          new Error(`Route error: ${error.status} ${error.statusText}`),
        );
      }
      return errorHandler.handleHttpError(error.status);
    } else if (error instanceof HttpError) {
      // Already reported by errorHandler - skip to avoid duplicate
      return error.message;
    } else if (error instanceof Error) {
      Sentry.captureException(error);
      return error.message;
    } else if (typeof error === "string") {
      Sentry.captureException(new Error(error));
      return error;
    } else {
      Sentry.captureException(new Error("Unknown route error"));
      return "Unknown error occurred";
    }
  }

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p>
        <i>{getErrorMessage()}</i>
      </p>
      <button
        onClick={() => {
          navigate(-1);
        }}
        className="mt-4 px-4 py-2 bg-black text-white rounded hover:bg-green-700"
      >
        Kate We Have To Go Back
      </button>
    </div>
  );
}
